import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";
//Components
import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";

//Actions
import { clearRedux, cloudLoginPageConfirmTemplate } from "Redux/actions";

const ConfirmTemplate = (props) => {
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const { confirmTemplateOpenModal } = useSelector(state => state.loginPageMainRedux)

    const closeModal = () => {
        dispatch(clearRedux("CLOUDLOGINPAGE_UPLOAD_IMAGE", { confirmTemplate: false, confirmTemplateOpenModal: false }))
    }

    const handleConfirm = () => {
        dispatch(cloudLoginPageConfirmTemplate(true))
        dispatch(clearRedux("CLOUDLOGINPAGE_UPLOAD_IMAGE", { confirmTemplateOpenModal: false }))
    }

    return (
        <Modal
            open={confirmTemplateOpenModal}
            title={messages['create_template_confirm_to_continue']}
            loading={false}
            position="right"
            size="small"
            handleClose={closeModal}
        >
            <ModalBody>
                <div style={{ padding: '0 10px', marginBottom: 30 }}>
                    <p>{messages['create_template_confirm_message_save']}</p>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['close']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => handleConfirm()}
                >
                    {messages['create_template_continue']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default ConfirmTemplate;